import React from 'react'
import PgaCoachJourney, { COACH_JOURNEY_QUERY } from '@layouts/pga-coach-journey'
import { fetchSSRData } from '@lib/ssr-fetch'

function CoachLandingPage(props) {
  return <PgaCoachJourney {...props} />
}

CoachLandingPage.getInitialProps = async ({ query }) => {
  const result = await fetchSSRData({
    query,
    graphqlQuery: COACH_JOURNEY_QUERY,
    variables: query,
    transform: (data) => data?.coachLandingPersonaDrivenCollection?.items?.[0],
  })

  return {
    ...result,
    ssrData: result.data,
  }
}

export default CoachLandingPage
